import { trans } from "@mongez/localization";
import { Button } from "~/design-system/components";
import { useFilters } from "../../hooks";

type ResetFiltersButtonProps = {
  onClick?: () => void;
};

export function ResetFiltersButton({ onClick }: ResetFiltersButtonProps) {
  const { resetFilters } = useFilters();

  const handleClick = () => {
    resetFilters();
    onClick?.();
  };

  return (
    <Button
      type="button"
      onClick={handleClick}
      className="w-full justify-center rounded-full border py-3 font-semibold uppercase"
    >
      {trans("reset")}
    </Button>
  );
}
